import { PosState } from './pos-reducer';
import { POS_ACTION_TYPE, PosActions } from './pos-type';

export const posCreators = {
  setPosState: <KeyName extends keyof PosState>(key: KeyName, value: PosState[KeyName])
    : PosActions => ({
      type: POS_ACTION_TYPE.SET_POS_STATE,
      payload: { key, value }
    }),
  callPosFoodMenu: (checkIsEmpty: (menu: []) => void, resetReload: () => void) => ({
    type: POS_ACTION_TYPE.CALL_POS_FOOD_MENU,
    checkIsEmpty,
    resetReload
  })
};
